import { getArtifactVersion } from '../../artifact-version/artifact-version';
import { biErrorLoggerFactory } from './bi-error-logger-factory';
import { BiErrorLogger } from './bi-error-logger.types';

const params = {
  artifactVersion: getArtifactVersion(),
};

let biErrorLogger: BiErrorLogger;

export const getBiErrorLogger = () => {
  if (!biErrorLogger) {
    biErrorLogger = biErrorLoggerFactory(params);
  }
  return biErrorLogger;
};
